import Buttons from '../Buttons/buttons';
import Options from '../../../../../home24-shared/components/quickview/components/Options/options';
import Title from '../../../../../home24-shared/components/quickview/components/Details/title';
import Price from '../../../../../home24-shared/components/quickview/components/Details/price';
import Delivery from '../../../../../home24-shared/components/quickview/components/Details/delivery';
import { lngprovider } from '../../../../../home24-shared/components/quickview/constants/languages';

const Stars = ({ className, isVisible, amount, valueInPercentage }) => {
  if (!isVisible) {
    return '';
  }
  return `
<div class="${className.DETAILS.STARS.WRAP}">
    <div class="${className.DETAILS.STARS.INNER}">
        <div style="width: ${valueInPercentage}%" class="${className.DETAILS.STARS.INSIDE}"></div>
    </div>
    <div class="${className.DETAILS.STARS.RATING}">
        (${amount})
    </div>
</div>
  `;
};

const Details = ({
  className,
  height,
  data: {
    stars,
    energyClass,
    price,
    isValuePack,
    delivery,
    url,
    name,
    variantName,
    mvcAttributes,
    selectedMvcAttributes,
    lngcode
  }
}) => {
  const lng = lngprovider(lngcode);
  return `
<div class="${className.DETAILS.WRAP}" style="height: ${height}px">
    ${Title({
      className,
      url,
      headline: name,
      subline: variantName
    })}
    ${Stars({
      className,
      isVisible: stars.isVisible,
      amount: stars.amount,
      valueInPercentage: stars.valueInPercentage
    })}
    ${Price({
      className,
      isReduced: price.isReduced,
      isRecommended: price.isRecommended,
      isValuePack,
      sellPrice: price.sellPrice,
      originalPrice: price.originalPrice,
      priceDifference: price.priceDifference,
      currency: price.currency,
      translations: lng,
      energyClass
    })}
    ${Delivery({
      className,
      translated: delivery.translated,
      isFastDelivery: delivery.isFastDelivery,
      DELIVERY: lng.DELIVERY
    })}
    ${Options({
      className,
      mvcAttributes: mvcAttributes,
      selectedMvcAttributes: selectedMvcAttributes
    })}
    ${Buttons({
      className,
      url,
      BUY: lng.BUY,
      PDP: lng.PDP
    })}
</div>
  `;
};

export default Details;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/components/Details/details.js
 **/